// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════
   International Draughts – Natural Wood Theme
   Inspired by KEV-CHECKERS physical board
   ═══════════════════════════════════════════════════════ */

.draughts-page {
  display: grid;
  gap: 12px;
}

.draughts-layout {
  display: grid;
  grid-template-columns: 240px minmax(280px, 1fr) 240px;
  gap: 12px;
  align-items: start;
}

.draughts-layout--practice {
  grid-template-columns: 220px minmax(280px, 1fr);
}

.draughts-layout--duel {
  grid-template-columns: 240px minmax(280px, 1fr);
}

.draughts-panel {
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 14px;
  padding: 12px;
  color: #e2e8f0;
  font-size: 14px;
}

/* ── Board wrapper with wood frame ────────────────────── */
.draughts-board-wrap {
  background:
    linear-gradient(135deg, #8B6914 0%, #A0792A 15%, #6B4F10 50%, #8B6914 85%, #A0792A 100%);
  border: 4px solid #5a3e08;
  border-radius: 14px;
  padding: 14px;
  display: grid;
  place-items: center;
  margin-inline: auto;
  box-shadow:
    0 2px 8px rgba(0,0,0,0.4),
    inset 0 1px 0 rgba(255,255,255,0.15);
}

/* 10×10 grid */
.draughts-board {
  display: grid;
  grid-template-columns: repeat(10, minmax(24px, 1fr));
  width: min(72vw, 560px);
  max-width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: inset 0 0 4px rgba(0,0,0,0.3);
}

/* ── Squares ──────────────────────────────────────────── */
.draughts-square {
  position: relative;
  border: none;
  padding: 0;
  margin: 0;
  display: grid;
  place-items: center;
  cursor: default;
  aspect-ratio: 1 / 1;
}

/* Light squares – white / cream */
.draughts-square--light {
  background: #fdfdfd;
}

/* Dark squares – green */
.draughts-square--dark {
  background: #198038;
  cursor: pointer;
}

/* Selected piece highlight */
.draughts-square--selected {
  box-shadow: inset 0 0 0 3px rgba(255, 215, 0, 0.9);
  background: #115c27; /* Darker green when selected */
}

/* Legal target indicators */
.draughts-square--target {
  position: relative;
}

.draughts-square--target::after {
  content: '';
  position: absolute;
  width: 34%;
  height: 34%;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.55);
  box-shadow: 0 0 6px rgba(76, 175, 80, 0.4);
  pointer-events: none;
  z-index: 2;
}

/* Target with a piece on it (capturable opponent) */
.draughts-square--target .draughts-piece {
  box-shadow:
    0 0 0 3px rgba(244, 67, 54, 0.7),
    0 0 10px rgba(244, 67, 54, 0.3);
}

/* Last move highlight */
.draughts-square--last {
  box-shadow: inset 0 0 0 3px rgba(66, 165, 245, 0.65);
}

/* ── Pieces ───────────────────────────────────────────── */
.draughts-piece {
  width: 78%;
  height: 78%;
  border-radius: 50%;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 1;
  transition: transform 0.1s ease;
  font-size: 0;  /* hide text, we use visual styling */
}

.draughts-square:not([disabled]):hover .draughts-piece {
  transform: scale(1.06);
}

/* ── White (Red) pieces ─── flat seeded disks ── */
.draughts-piece--white {
  background: repeating-radial-gradient(
    circle at 50% 50%,
    #d12121 0%,
    #e52e2e 10%,
    #d12121 20%
  );
  border: 1px solid #731313;
  box-shadow: 
    0 2px 0 #731313,
    0 3px 4px rgba(0,0,0,0.4);
}

/* ── Black (Dark Grey) pieces ─── flat seeded disks ── */
.draughts-piece--black {
  background: repeating-radial-gradient(
    circle at 50% 50%,
    #303030 0%,
    #424242 10%,
    #303030 20%
  );
  border: 1px solid #141414;
  box-shadow: 
    0 2px 0 #141414,
    0 3px 4px rgba(0,0,0,0.4);
}

/* ── King crown ring ─────────────────────────────────── */
.draughts-piece--king {
  position: relative;
}

.draughts-piece--king::before {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  border: 3px solid transparent;
  pointer-events: none;
}

.draughts-piece--white.draughts-piece--king::before {
  border-color: #ffd700;
  box-shadow:
    0 0 6px rgba(255, 215, 0, 0.5),
    inset 0 0 4px rgba(255, 215, 0, 0.3);
}

.draughts-piece--black.draughts-piece--king::before {
  border-color: #90caf9;
  box-shadow:
    0 0 6px rgba(144, 202, 249, 0.5),
    inset 0 0 4px rgba(144, 202, 249, 0.3);
}

/* King crown symbol (inner dot/star) */
.draughts-piece--king::after {
  content: '★';
  position: absolute;
  font-size: clamp(9px, 1.4vw, 14px);
  line-height: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.draughts-piece--white.draughts-piece--king::after {
  color: #ffd700;
  text-shadow: 0 0 3px rgba(0,0,0,0.4);
}

.draughts-piece--black.draughts-piece--king::after {
  color: #bbdefb;
  text-shadow: 0 0 3px rgba(0,0,0,0.5);
}

.draughts-piece--movable {
  cursor: pointer;
}

.draughts-piece--movable.draughts-piece--white {
  box-shadow:
    0 2px 0 #731313,
    0 3px 4px rgba(0,0,0,0.4),
    0 0 10px rgba(239, 68, 68, 0.6);
}

.draughts-piece--movable.draughts-piece--black {
  box-shadow:
    0 2px 0 #141414,
    0 3px 4px rgba(0,0,0,0.4),
    0 0 10px rgba(156, 163, 175, 0.6);
}

/* ── Mandatory move highlight (when must_continue_from is active) ── */
.draughts-square--must {
  box-shadow: inset 0 0 0 4px #facc15, 0 0 12px rgba(250, 204, 21, 0.4);
  z-index: 3;
}

.draughts-piece--must-active {
  animation: draughts-pulse-must 1.5s infinite ease-in-out;
  border-color: #facc15 !important;
}

@keyframes draughts-pulse-must {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.7); }
  50% { transform: scale(1.08); box-shadow: 0 0 0 8px rgba(250, 204, 21, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(250, 204, 21, 0); }
}

/* ── File/rank labels ────────────────────────────────── */
.draughts-board-labels-top,
.draughts-board-labels-bottom {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  width: 100%;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #f1dec0;
  letter-spacing: 1px;
  -webkit-user-select: none;
          user-select: none;
}

.draughts-board-labels-top {
  margin-bottom: 2px;
}

.draughts-board-labels-bottom {
  margin-top: 2px;
}

.draughts-board-labels-left,
.draughts-board-labels-right {
  display: grid;
  grid-template-rows: repeat(10, 1fr);
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #f1dec0;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
}

.draughts-board-labels-left {
  margin-right: 4px;
}

.draughts-board-labels-right {
  margin-left: 4px;
}

/* Board with labels container */
.draughts-board-with-labels {
  display: grid;
  grid-template-columns: 18px 1fr 18px;
  grid-template-rows: 18px 1fr 18px;
  gap: 0;
  width: min(72vw, 580px);
  max-width: 100%;
  margin-inline: auto;
}

/* ── Draughts board wrapper for vertical (chess-match-page) layout ── */
.dm-board-wrap {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  min-height: 0;
  overflow: hidden;
}

.dm-board-wrap .draughts-board-wrap {
  padding: 10px;
  max-width: calc(100vw - 4px);
  box-sizing: border-box;
}

.dm-board-wrap .draughts-board-with-labels {
  width: min(100vw - 56px, 100vh - 260px, 560px);
}

.dm-board-wrap .draughts-board {
  width: 100%;
}

.draughts-board-with-labels .draughts-board {
  width: 100%;
}

/* ── Clock & UI ──────────────────────────────────────── */
.draughts-clock {
  font-size: 18px;
  font-weight: 700;
}

.draughts-active-turn {
  color: #facc15;
}
.draughts-turn-alert {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.2px;
  color: #052e16;
  background: linear-gradient(90deg, #86efac, #bbf7d0);
  border: 1px solid #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.12);
}

/* ── Responsive ──────────────────────────────────────── */
@media (max-width: 1080px) {
  .draughts-layout {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .draughts-board-wrap {
    order: 1;
  }

  .draughts-panel--meta {
    order: 2;
  }

  .draughts-board-with-labels {
    width: min(calc(100vw - 72px), 520px);
    margin-inline: auto;
  }

  .draughts-board {
    width: 100%;
  }

  .draughts-panel {
    font-size: 13px;
  }
}

@media (max-width: 640px) {
  .draughts-board-wrap {
    padding: 8px;
    overflow-x: hidden;
  }

  .draughts-board-with-labels {
    width: min(calc(100vw - 68px), 420px);
    grid-template-columns: 12px 1fr 12px;
    grid-template-rows: 12px 1fr 12px;
    margin-inline: auto;
  }

  .draughts-board-labels-top,
  .draughts-board-labels-bottom,
  .draughts-board-labels-left,
  .draughts-board-labels-right {
    font-size: 8px;
  }

  .draughts-board {
    width: 100%;
  }

  .draughts-panel {
    padding: 8px;
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .draughts-board-with-labels {
    width: calc(100vw - 68px);
    grid-template-columns: 10px 1fr 10px;
    grid-template-rows: 10px 1fr 10px;
    margin-inline: auto;
  }

  .draughts-board-labels-top,
  .draughts-board-labels-bottom,
  .draughts-board-labels-left,
  .draughts-board-labels-right {
    font-size: 7px;
  }

  .draughts-piece {
    font-size: 10px;
  }
}

/* ── Responsive overrides for dm-board-wrap (vertical layout) ── */
@media (max-width: 640px) {
  .dm-board-wrap .draughts-board-wrap {
    padding: 6px;
  }

  .dm-board-wrap .draughts-board-with-labels {
    width: min(100vw - 32px, 100vh - 240px, 480px);
    grid-template-columns: 12px 1fr 12px;
    grid-template-rows: 12px 1fr 12px;
  }
}

@media (max-width: 400px) {
  .dm-board-wrap .draughts-board-wrap {
    padding: 4px;
    border-width: 3px;
  }

  .dm-board-wrap .draughts-board-with-labels {
    width: min(100vw - 22px, 100vh - 220px);
    grid-template-columns: 10px 1fr 10px;
    grid-template-rows: 10px 1fr 10px;
  }
}

@media (min-width: 601px) {
  .dm-board-wrap .draughts-board-with-labels {
    width: min(100vw - 56px, 100vh - 260px, 520px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Draughts.css"],"names":[],"mappings":"AAAA;;;4DAG4D;;AAE5D;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE;4FAC0F;EAC1F,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;;wCAEsC;AACxC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oDAAoD;EACpD,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kDAAkD;EAClD,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;AACZ;;AAEA,oDAAoD;AACpD;EACE;;mCAEiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,oDAAoD;AACtD;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,YAAY,GAAG,qCAAqC;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE;;;;;GAKC;EACD,yBAAyB;EACzB;;6BAE2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE;;;;;GAKC;EACD,yBAAyB;EACzB;;6BAE2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB;;wCAEsC;AACxC;;AAEA;EACE,qBAAqB;EACrB;;0CAEwC;AAC1C;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;;mCAGiC;AACnC;;AAEA;EACE;;;qCAGmC;AACrC;;AAEA,uEAAuE;AACvE;EACE,qEAAqE;EACrE,UAAU;AACZ;;AAEA;EACE,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA;EACE,KAAK,mBAAmB,EAAE,2CAA2C,EAAE;EACvE,MAAM,sBAAsB,EAAE,2CAA2C,EAAE;EAC3E,OAAO,mBAAmB,EAAE,yCAAyC,EAAE;AACzE;;AAEA,2DAA2D;AAC3D;;EAEE,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,MAAM;EACN,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,oDAAoD;EACpD,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,2DAA2D;AAC3D;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,oCAAoC;IACpC,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,YAAY;EACd;;EAEA;IACE,8CAA8C;IAC9C,oCAAoC;IACpC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;IACvC,oCAAoC;IACpC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════\n   International Draughts – Natural Wood Theme\n   Inspired by KEV-CHECKERS physical board\n   ═══════════════════════════════════════════════════════ */\n\n.draughts-page {\n  display: grid;\n  gap: 12px;\n}\n\n.draughts-layout {\n  display: grid;\n  grid-template-columns: 240px minmax(280px, 1fr) 240px;\n  gap: 12px;\n  align-items: start;\n}\n\n.draughts-layout--practice {\n  grid-template-columns: 220px minmax(280px, 1fr);\n}\n\n.draughts-layout--duel {\n  grid-template-columns: 240px minmax(280px, 1fr);\n}\n\n.draughts-panel {\n  background: rgba(15, 23, 42, 0.75);\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  border-radius: 14px;\n  padding: 12px;\n  color: #e2e8f0;\n  font-size: 14px;\n}\n\n/* ── Board wrapper with wood frame ────────────────────── */\n.draughts-board-wrap {\n  background:\n    linear-gradient(135deg, #8B6914 0%, #A0792A 15%, #6B4F10 50%, #8B6914 85%, #A0792A 100%);\n  border: 4px solid #5a3e08;\n  border-radius: 14px;\n  padding: 14px;\n  display: grid;\n  place-items: center;\n  margin-inline: auto;\n  box-shadow:\n    0 2px 8px rgba(0,0,0,0.4),\n    inset 0 1px 0 rgba(255,255,255,0.15);\n}\n\n/* 10×10 grid */\n.draughts-board {\n  display: grid;\n  grid-template-columns: repeat(10, minmax(24px, 1fr));\n  width: min(72vw, 560px);\n  max-width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: inset 0 0 4px rgba(0,0,0,0.3);\n}\n\n/* ── Squares ──────────────────────────────────────────── */\n.draughts-square {\n  position: relative;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  place-items: center;\n  cursor: default;\n  aspect-ratio: 1 / 1;\n}\n\n/* Light squares – white / cream */\n.draughts-square--light {\n  background: #fdfdfd;\n}\n\n/* Dark squares – green */\n.draughts-square--dark {\n  background: #198038;\n  cursor: pointer;\n}\n\n/* Selected piece highlight */\n.draughts-square--selected {\n  box-shadow: inset 0 0 0 3px rgba(255, 215, 0, 0.9);\n  background: #115c27; /* Darker green when selected */\n}\n\n/* Legal target indicators */\n.draughts-square--target {\n  position: relative;\n}\n\n.draughts-square--target::after {\n  content: '';\n  position: absolute;\n  width: 34%;\n  height: 34%;\n  border-radius: 50%;\n  background: rgba(76, 175, 80, 0.55);\n  box-shadow: 0 0 6px rgba(76, 175, 80, 0.4);\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* Target with a piece on it (capturable opponent) */\n.draughts-square--target .draughts-piece {\n  box-shadow:\n    0 0 0 3px rgba(244, 67, 54, 0.7),\n    0 0 10px rgba(244, 67, 54, 0.3);\n}\n\n/* Last move highlight */\n.draughts-square--last {\n  box-shadow: inset 0 0 0 3px rgba(66, 165, 245, 0.65);\n}\n\n/* ── Pieces ───────────────────────────────────────────── */\n.draughts-piece {\n  width: 78%;\n  height: 78%;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  position: relative;\n  z-index: 1;\n  transition: transform 0.1s ease;\n  font-size: 0;  /* hide text, we use visual styling */\n}\n\n.draughts-square:not([disabled]):hover .draughts-piece {\n  transform: scale(1.06);\n}\n\n/* ── White (Red) pieces ─── flat seeded disks ── */\n.draughts-piece--white {\n  background: repeating-radial-gradient(\n    circle at 50% 50%,\n    #d12121 0%,\n    #e52e2e 10%,\n    #d12121 20%\n  );\n  border: 1px solid #731313;\n  box-shadow: \n    0 2px 0 #731313,\n    0 3px 4px rgba(0,0,0,0.4);\n}\n\n/* ── Black (Dark Grey) pieces ─── flat seeded disks ── */\n.draughts-piece--black {\n  background: repeating-radial-gradient(\n    circle at 50% 50%,\n    #303030 0%,\n    #424242 10%,\n    #303030 20%\n  );\n  border: 1px solid #141414;\n  box-shadow: \n    0 2px 0 #141414,\n    0 3px 4px rgba(0,0,0,0.4);\n}\n\n/* ── King crown ring ─────────────────────────────────── */\n.draughts-piece--king {\n  position: relative;\n}\n\n.draughts-piece--king::before {\n  content: '';\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  right: -3px;\n  bottom: -3px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  pointer-events: none;\n}\n\n.draughts-piece--white.draughts-piece--king::before {\n  border-color: #ffd700;\n  box-shadow:\n    0 0 6px rgba(255, 215, 0, 0.5),\n    inset 0 0 4px rgba(255, 215, 0, 0.3);\n}\n\n.draughts-piece--black.draughts-piece--king::before {\n  border-color: #90caf9;\n  box-shadow:\n    0 0 6px rgba(144, 202, 249, 0.5),\n    inset 0 0 4px rgba(144, 202, 249, 0.3);\n}\n\n/* King crown symbol (inner dot/star) */\n.draughts-piece--king::after {\n  content: '★';\n  position: absolute;\n  font-size: clamp(9px, 1.4vw, 14px);\n  line-height: 1;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.draughts-piece--white.draughts-piece--king::after {\n  color: #ffd700;\n  text-shadow: 0 0 3px rgba(0,0,0,0.4);\n}\n\n.draughts-piece--black.draughts-piece--king::after {\n  color: #bbdefb;\n  text-shadow: 0 0 3px rgba(0,0,0,0.5);\n}\n\n.draughts-piece--movable {\n  cursor: pointer;\n}\n\n.draughts-piece--movable.draughts-piece--white {\n  box-shadow:\n    0 2px 0 #731313,\n    0 3px 4px rgba(0,0,0,0.4),\n    0 0 10px rgba(239, 68, 68, 0.6);\n}\n\n.draughts-piece--movable.draughts-piece--black {\n  box-shadow:\n    0 2px 0 #141414,\n    0 3px 4px rgba(0,0,0,0.4),\n    0 0 10px rgba(156, 163, 175, 0.6);\n}\n\n/* ── Mandatory move highlight (when must_continue_from is active) ── */\n.draughts-square--must {\n  box-shadow: inset 0 0 0 4px #facc15, 0 0 12px rgba(250, 204, 21, 0.4);\n  z-index: 3;\n}\n\n.draughts-piece--must-active {\n  animation: draughts-pulse-must 1.5s infinite ease-in-out;\n  border-color: #facc15 !important;\n}\n\n@keyframes draughts-pulse-must {\n  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.7); }\n  50% { transform: scale(1.08); box-shadow: 0 0 0 8px rgba(250, 204, 21, 0); }\n  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(250, 204, 21, 0); }\n}\n\n/* ── File/rank labels ────────────────────────────────── */\n.draughts-board-labels-top,\n.draughts-board-labels-bottom {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  width: 100%;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #f1dec0;\n  letter-spacing: 1px;\n  user-select: none;\n}\n\n.draughts-board-labels-top {\n  margin-bottom: 2px;\n}\n\n.draughts-board-labels-bottom {\n  margin-top: 2px;\n}\n\n.draughts-board-labels-left,\n.draughts-board-labels-right {\n  display: grid;\n  grid-template-rows: repeat(10, 1fr);\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #f1dec0;\n  user-select: none;\n  align-items: center;\n}\n\n.draughts-board-labels-left {\n  margin-right: 4px;\n}\n\n.draughts-board-labels-right {\n  margin-left: 4px;\n}\n\n/* Board with labels container */\n.draughts-board-with-labels {\n  display: grid;\n  grid-template-columns: 18px 1fr 18px;\n  grid-template-rows: 18px 1fr 18px;\n  gap: 0;\n  width: min(72vw, 580px);\n  max-width: 100%;\n  margin-inline: auto;\n}\n\n/* ── Draughts board wrapper for vertical (chess-match-page) layout ── */\n.dm-board-wrap {\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.dm-board-wrap .draughts-board-wrap {\n  padding: 10px;\n  max-width: calc(100vw - 4px);\n  box-sizing: border-box;\n}\n\n.dm-board-wrap .draughts-board-with-labels {\n  width: min(100vw - 56px, 100vh - 260px, 560px);\n}\n\n.dm-board-wrap .draughts-board {\n  width: 100%;\n}\n\n.draughts-board-with-labels .draughts-board {\n  width: 100%;\n}\n\n/* ── Clock & UI ──────────────────────────────────────── */\n.draughts-clock {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.draughts-active-turn {\n  color: #facc15;\n}\n.draughts-turn-alert {\n  margin-bottom: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  letter-spacing: 0.2px;\n  color: #052e16;\n  background: linear-gradient(90deg, #86efac, #bbf7d0);\n  border: 1px solid #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.12);\n}\n\n/* ── Responsive ──────────────────────────────────────── */\n@media (max-width: 1080px) {\n  .draughts-layout {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .draughts-board-wrap {\n    order: 1;\n  }\n\n  .draughts-panel--meta {\n    order: 2;\n  }\n\n  .draughts-board-with-labels {\n    width: min(calc(100vw - 72px), 520px);\n    margin-inline: auto;\n  }\n\n  .draughts-board {\n    width: 100%;\n  }\n\n  .draughts-panel {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 640px) {\n  .draughts-board-wrap {\n    padding: 8px;\n    overflow-x: hidden;\n  }\n\n  .draughts-board-with-labels {\n    width: min(calc(100vw - 68px), 420px);\n    grid-template-columns: 12px 1fr 12px;\n    grid-template-rows: 12px 1fr 12px;\n    margin-inline: auto;\n  }\n\n  .draughts-board-labels-top,\n  .draughts-board-labels-bottom,\n  .draughts-board-labels-left,\n  .draughts-board-labels-right {\n    font-size: 8px;\n  }\n\n  .draughts-board {\n    width: 100%;\n  }\n\n  .draughts-panel {\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 400px) {\n  .draughts-board-with-labels {\n    width: calc(100vw - 68px);\n    grid-template-columns: 10px 1fr 10px;\n    grid-template-rows: 10px 1fr 10px;\n    margin-inline: auto;\n  }\n\n  .draughts-board-labels-top,\n  .draughts-board-labels-bottom,\n  .draughts-board-labels-left,\n  .draughts-board-labels-right {\n    font-size: 7px;\n  }\n\n  .draughts-piece {\n    font-size: 10px;\n  }\n}\n\n/* ── Responsive overrides for dm-board-wrap (vertical layout) ── */\n@media (max-width: 640px) {\n  .dm-board-wrap .draughts-board-wrap {\n    padding: 6px;\n  }\n\n  .dm-board-wrap .draughts-board-with-labels {\n    width: min(100vw - 32px, 100vh - 240px, 480px);\n    grid-template-columns: 12px 1fr 12px;\n    grid-template-rows: 12px 1fr 12px;\n  }\n}\n\n@media (max-width: 400px) {\n  .dm-board-wrap .draughts-board-wrap {\n    padding: 4px;\n    border-width: 3px;\n  }\n\n  .dm-board-wrap .draughts-board-with-labels {\n    width: min(100vw - 22px, 100vh - 220px);\n    grid-template-columns: 10px 1fr 10px;\n    grid-template-rows: 10px 1fr 10px;\n  }\n}\n\n@media (min-width: 601px) {\n  .dm-board-wrap .draughts-board-with-labels {\n    width: min(100vw - 56px, 100vh - 260px, 520px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
